<script setup>
import { ref, reactive, onMounted, computed } from 'vue';
import { ElMessage, ElLoading } from 'element-plus';
import request from '@/utils/request';
import { useRouter } from 'vue-router';
import { Plus } from '@element-plus/icons-vue';
import { sliceUpload } from '@/utils/api.js';

// 表单引用
const formRef = ref();
const uploadRef = ref();
const router = useRouter();

// 表单数据
const form = reactive({
  projectName: '',
  description: '',
  category: '',
  group: '',
  applicationFile: null,
  workFile: null,
  demoFile: null,
});

// 文件列表
const fileList = ref([]);

// 我的作品
const myProjects = ref([]);

// 表单验证规则
const rules = {
  projectName: [
    { required: true, message: '请输入作品名称', trigger: 'blur' },
    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
  ],
  description: [
    { required: true, message: '请输入作品描述', trigger: 'blur' },
    { min: 10, message: '描述至少 10 个字符', trigger: 'blur' }
  ],
  category: [
    { required: true, message: '请选择作品分类', trigger: 'change' }
  ],
  applicationFile: [
    { required: true, message: '请选择作品文件', trigger: 'change' }
  ],
  isPhysicalObject: [
    { required: true, message: '请选择作品形式', trigger: 'change' }
  ],
  workFile: [
    { required: true, message: '请选择作品文件', trigger: 'change' }
  ],
  demoTypes: [
    { required: true, message: '请选择作品演示形式', trigger: 'change' }
  ],
  demoFile: [
    { required: true, message: '请选择作品文件', trigger: 'change' }
  ]
};

// 处理文件变化
const workFileChange = (file) => {
  form.file = file.raw;
  // console.log('上传成功', file);
  sliceUpload(form.file).then(res=>{
    console.log('结果', res);
    // form.workFile = res.data;
  })
};


const demoFileChange = (file) => {
  form.file = file.raw;
  // console.log('上传成功', file);
  sliceUpload(form.file).then(res=>{
    console.log('结果', res);
    // form.demoFile = res.data;
  })
};


const applicationFileChange = (file) => {
  form.file = file.raw;
  sliceUpload(form.file).then(res=>{
    console.log('结果', res);
    // form.applicationFile = res.data;
  })
};

const loading = ref(false)
const percentage = ref(0)
const onProgress = (e) => {
  if (e.loaded === e.total) {
    loading.value = false
    percentage.value = 0
  } else {
    loading.value = true
    percentage.value = parseInt((e.loaded / e.total) * 100 + '')
  }
}

// 处理文件超出限制
const handleExceed = (files) => {
  ElMessage.warning(`只能上传一个文件，已自动忽略多余的 ${files.length} 个文件`);
};

// 提交表单
const handleSubmit = async () => {
  try {
    // 表单验证
    await formRef.value.validate();
    
    // 创建FormData对象
    const formData = new FormData();
    formData.append('projectName', form.projectName);
    formData.append('description', form.description);
    formData.append('category', form.category);
    formData.append('applicationFile', form.applicationFile);
    formData.append('workFile', form.workFile);
    formData.append('demoFile', form.demoFile);
    
    // 显示加载
    const loading = ElLoading.service({
      lock: true,
      text: '正在上传作品...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    
    // 提交数据
    await request.post('/projects', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    // 关闭加载
    loading.close();
    
    ElMessage.success('作品上传成功！');
    
    // 重置表单
    handleReset();
    
    // 重新加载作品列表
    loadMyProjects();
  } catch (error) {
    // 验证失败不处理
    if (error.name === 'ValidationError') return;
    
    ElMessage.error('上传失败: ' + (error.message || '未知错误'));
  }
};

// 重置表单
const handleReset = () => {
  formRef.value.resetFields();
  fileList.value = [];
  form.file = null;
};

// 加载我的作品
const loadMyProjects = async () => {
  try {
    const data = await request.get('projects/my-projects');
    myProjects.value = data;
  } catch (error) {
    ElMessage.error('加载作品列表失败: ' + (error.message || '未知错误'));
  }
};

// 下载文件
const downloadFile = async (fileUrl) => {
  if (!fileUrl) return;
  
  try {
    const response = await request.get(fileUrl, {
      responseType: 'blob'
    });
    
    // 创建下载链接
    const url = window.URL.createObjectURL(new Blob([response]));
    const a = document.createElement('a');
    a.href = url;
    
    // 从URL中提取文件名
    const fileName = fileUrl.split('/').pop();
    a.download = fileName;
    
    document.body.appendChild(a);
    a.click();
    
    // 清理
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    ElMessage.error('下载失败: ' + (error.message || '未知错误'));
  }
};

// 查看评审结果
const viewResult = (projectId) => {
  router.push({
    path: '/results',
    query: { projectId }
  });
};

// 组件挂载时加载数据
onMounted(loadMyProjects);

const currentTime = new Date()
const year = currentTime.getFullYear()
const month = currentTime.getMonth() + 1
const day = currentTime.getDate()
const defaultTime2 = [
  new Date(year, month, day, 12, 0, 0),
  new Date(year, month, day, 23, 59, 59)
]

const dynamicValidateForm = reactive({
  name: '测试', 
  description: '测试一下子',
  type: ['科学节','数学节','夏令营'],
  date2: defaultTime2,
  poster: '',
  tables: [
    {
      key: 'item_1',
      value: '',
      name: '作品名称',
      type: 'text',
      required: 1,
      subtables: [],
      options: []
    },
    {
      key: 'item_2',
      value: '',
      name: '作品组别',
      type: 'select',
      subtables: [],
      options: ['小学组','初中组','高中组']
    },
    {
      key: 'item_3',
      value: '',
      name: '作品故事',
      type: 'file',
      subtables: [],
      options: ['小学组','初中组','高中组']
    },
    {
      key: 'item_4',
      value: '',
      name: '作者信息（限报3人）',
      type: 'table',
      options: ['测试','123'],
      subtables: {
        // rows: ['第一作者','第二作者'],
        rows: [
          {
            label: '第一作者',
          },
          {
            label: '第二作者',
          }
        ],
        columns: [
          {
            key: 'col_1',
            value: '',
            name: '姓名',
            type: 'text',
            options: []
          },
          {
            key: 'col_2',
            value: '',
            name: '联系方式',
            type: 'select',
            options: ['测试','123']
          },
        ]
      }
    },
  ],
  
})


const tableData = computed(()=>{
  const data = []
  const tableObj = {}
  dynamicValidateForm.tables.map(table=>{
    switch(table.type){
      case 'text':
      case 'select':
      case 'file':
        // data.push({
        //   [table.key] : ''
        // })
        tableObj[table.key] = ''
        break
      case 'table':{

      
       
        console.log('table.key',table.key)
        console.log('data[table.key]',data[table.key])
        console.log('table.subtables.columns',table.subtables.columns)
        let obj = {}
        let rows = []
        table.subtables.columns.map(item=>{
            console.log('item',item)
            return obj[item.key] = ''
        })
        table.subtables.rows.map((item,index)=>{
          console.log('item',item)
          rows.push({
            ...obj,
          })
        })

        //  data.push({
        //   [table.key] : rows
        // })
        tableObj[table.key] = rows
        break
      }
    }
  })
  return tableObj
})
console.log('tableData',tableData.value)
</script>

<template>
  <div>
    <div class="upload-container">
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="formRef"
        label-suffix="："
        label-width="200px"
        class="upload-form"
      >
        <div class="title">申请表</div>

        <template v-for="(table) in dynamicValidateForm.tables" :key="table.key">
          <el-form-item :label="table.name" :class="table.type === 'table' ? 'test' : ''">
            <template v-if="table.type === 'text'">
              <el-input v-model="table.value" :placeholder="'请输入'+table.name" />
            </template>
            <template v-else-if="table.type === 'textarea'">
              <el-input v-model="table.value" type="textarea" />
            </template>
            <template v-else-if="table.type === 'number'">
              <el-input-number v-model="table.value" />
            </template>
            <template v-else-if="table.type === 'file'">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :accept="table.fileType"
                :on-success="handleAvatarSuccess"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </template>
            <template v-else-if="table.type === 'pic'">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </template>
            <template v-else-if="table.type === 'date'">
              <el-date-picker
                v-model="table.value"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </template>
            <template v-else-if="table.type === 'select'">
              <el-select v-model="table.value" placeholder="请选择">
                <el-option v-for="(item,index) in table.options" :key="index" :label="item" :value="item" />
              </el-select>
            </template>
            <template v-else-if="table.type === 'radio'">
              <el-radio-group v-model="table.value" size="small">
                <el-radio v-for="(item,index) in table.options" :key="index" :label="item" :value="item" />
              </el-radio-group>
            </template>
            <template v-else-if="table.type === 'checkbox'">
              <el-checkbox-group v-model="checkboxValues" size="small">
                <el-checkbox v-for="(item,index) in table.options" :key="index" :label="item" :value="item" />
              </el-checkbox-group>
            </template>
            <template v-else-if="table.type === 'table'">
              <el-table :data="tableData[table.key]" style="width: 100%" border stripe>
                <el-table-column type="index" :index="(index)=>{
                  return table.subtables.rows[index].label
                }"  width="120"/>
                <el-table-column 
                  v-for="(col, index) in table.subtables.columns" 
                  :key="index"
                  :prop="col.type"
                  :label="col.name"
                  min-width="120"
                >
                  <template #default="scpoed">
                    <el-input 
                      v-if="col.type === 'text'"
                      v-model="scpoed.row[col.key]"
                      :placeholder="`请输入${col.name}`"
                    />
                    <el-select 
                      v-else-if="col.type === 'select'"
                      v-model="scpoed.row[col.type]"
                      :placeholder="`请选择${col.name}`"
                    >
                      <el-option 
                        v-for="option in col.options" 
                        :key="option" 
                        :label="option" 
                        :value="option"
                      />
                    </el-select>
                    <el-input-number 
                      v-else-if="col.type === 'number'"
                      v-model="scpoed.row[col.type]"
                    />
                    <!-- 其他类型... -->
                    <el-upload v-else-if="col.type === 'file'"
                      class="avatar-uploader"
                      :action="uploadUrl"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </template>
                </el-table-column>
                
              </el-table>

            </template>
            <template v-else>
              <el-input v-model="table.value" />
            </template>
          </el-form-item>
        </template>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">
            提交作品
          </el-button>
          <el-button @click="handleReset" style="margin-left: 10px">
            重置
          </el-button>
        </el-form-item>






        <!-- <el-form-item label="作品名称" prop="projectName">
          <el-input 
            v-model="form.projectName" 
            placeholder="请输入作品名称"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="作品描述" prop="description">
          <el-input 
            v-model="form.description" 
            type="textarea" 
            rows="4"
            placeholder="请描述你的作品"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="作品类别" prop="category">
          <el-select 
            v-model="form.category" 
            placeholder="请选择作品类别"
          >
            <el-option label="趣味创意" value="1"></el-option>
            <el-option label="益智创新" value="2"></el-option>
            <el-option label="科普创新" value="3"></el-option>
            <el-option label="发明创造" value="4"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="作品组别" prop="category">
          <el-select 
            v-model="form.group" 
            placeholder="请选择作品组别"
          >
            <el-option label="小学组" value="1"></el-option>
            <el-option label="初中组" value="2"></el-option>
            <el-option label="高中组" value="3"></el-option>
          </el-select>
        </el-form-item> -->
        
        <!-- <el-row style="display: flex; justify-content: space-between;">
          <el-form-item label="作品申请表" prop="applicationFile">
            <el-upload
              ref="uploadRef"
              action=""
              :auto-upload="false"
              :on-change="applicationFileChange"
              :file-list="fileList"
              :limit="1"
              :on-progress="onProgress"
              :on-exceed="handleExceed"
              accept=".docx,.doc"
            >
              <template #default>
                <div class="file-input">
                  <el-icon style="font-size: 12px;"><plus /></el-icon>
                  上传文件
                </div>
              </template>
              <template #tip>
                <div class="el-upload__tip">
                  支持上传 doc, docx格式文件，最大 5MB
                </div>
              </template>
            </el-upload>
          </el-form-item>

          <span>
            <a href="/template.docx" download>模板下载</a>
          </span>
        </el-row>

        <el-progress v-if="loading" :percentage="percentage" :color="colors"></el-progress> -->

        <!-- <el-form-item label="作品形式" prop="isPhysicalObject">
          <el-radio-group v-model="form.isPhysicalObject" style="
            display: flex; gap: 12px;width: 100%;">
            <el-radio label="1">实物</el-radio>
            <el-radio label="2">非实物</el-radio>
          </el-radio-group>
          <div style="color: #696666;font-size: 12px;">
            除了实物之外，都需要上传作品
          </div>
        </el-form-item>

        <el-form-item v-show="form.isPhysicalObject === '2'" prop="workFile">
          <el-upload
            ref="uploadRef"
            action=""
            :auto-upload="false"
            :on-change="workFileChange"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
            accept=".zip,.rar,.pdf,.doc,.docx,.ppt,.pptx"
          >
            <template #default>
              <div class="file-input">
                <el-icon style="font-size: 12px;"><plus /></el-icon>
                上传文件
              </div>
            </template>
            <template #tip>
              <div class="el-upload__tip">
                支持上传 zip, rar, pdf, doc, docx, ppt, pptx 格式文件，最大 200MB
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item label="作品演示形式" prop="demoTypes">
          <el-radio-group v-model="form.demoTypes" style="display: flex; gap: 12px;">
            <el-radio label="1">作品使用方法/演示视频</el-radio>
            <el-radio label="2">数字媒体作品源文件</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="demoFile" v-show="form.demoTypes === '1'" >
          <el-upload
            ref="uploadRef"
            action=""
            :auto-upload="false"
            :on-change="demoFileChange"
            :file-list="fileList"
            :limit="1"
            :on-progress="onProgress"
            :on-exceed="handleExceed"
            accept=".pdf,.doc,.docx,.ppt,.pptx,.mp4,.wmv,.mpg"
          >
            <template #default>
              <div class="file-input">
                <el-icon style="font-size: 12px;"><plus /></el-icon>
                上传文件  
              </div>
            </template>
            <template #tip>
              <div class="el-upload__tip">
                支持上传 pdf, doc, docx, ppt, pptx, mp4, wmv, mpg 格式文件，最大 200MB，演示视频一般不超过3分钟
              </div>
            </template>
          </el-upload>
        </el-form-item> -->


        <el-form-item prop="demoFile" v-show="form.demoTypes === '2'">
          <el-upload
            ref="uploadRef"
            action=""
            :auto-upload="false"
            :on-change="demoFileChange"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
            accept="*"
          >
            <template #default>
              <div class="file-input">
                <el-icon style="font-size: 12px;"><plus /></el-icon>
                上传文件
              </div>
            </template>
            <template #tip>
              <div class="el-upload__tip">
                <!-- 支持上传 zip, rar, pdf, doc, docx, ppt, pptx 格式文件，最大 200MB -->
                对于数字媒体作品，需要提供程序的源文件或其他格式的数字文件
              </div>
            </template>
          </el-upload>
        </el-form-item>


        <el-form-item label="我的作品故事" prop="storyFile">
          <el-upload
            ref="uploadRef"
            action=""
            :auto-upload="false"
            :on-change="demoFileChange"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
            accept="*"
          >
            <!-- <el-button type="primary">选择文件</el-button> -->
            <template #default>
              <div class="file-input">
                <el-icon style="font-size: 12px;"><plus /></el-icon>
                上传文档
              </div>
            </template>
            <template #tip>
              <div class="el-upload__tip">
                <!-- 支持上传 zip, rar, pdf, doc, docx, ppt, pptx 格式文件，最大 200MB -->
                主要内容包括创作背景/灵感、创作意图、完成过程、创想点等
              </div>
            </template>
          </el-upload>

          <el-upload
            ref="uploadRef"
            action=""
            :auto-upload="false"
            :on-change="demoFileChange"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
            accept="*"
          >
            <!-- <el-button type="primary">选择文件</el-button> -->
            <template #default>
              <div class="file-input">
                <el-icon style="font-size: 12px;"><plus /></el-icon>
                上传照片
              </div>
            </template>
            <template #tip>
              <div class="el-upload__tip">
                <!-- 支持上传 zip, rar, pdf, doc, docx, ppt, pptx 格式文件，最大 200MB -->
                多角度拍摄反映作品本身、完成过程的照片，至少3张
              </div>
            </template>
          </el-upload>
        </el-form-item>
        
      </el-form>
      
      <!-- 作品列表 -->
      <div class="project-list">
        <h3>我的作品</h3>
        <el-table 
          :data="myProjects" 
          border 
          style="width: 100%"
        >
          <el-table-column 
            prop="projectName" 
            label="作品名称" 
            width="200"
          ></el-table-column>
          <el-table-column 
            prop="category" 
            label="分类" 
            width="120"
          ></el-table-column>
          <el-table-column 
            prop="submitTime" 
            label="提交时间" 
            width="180"
          ></el-table-column>
          <el-table-column 
            prop="status" 
            label="状态" 
            width="120"
          >
            <template #default="scope">
              <el-tag 
                :type="scope.row.status === 'pending' ? 'warning' : 'success'"
                size="small"
              >
                {{ scope.row.status === 'pending' ? '待评审' : '已评审' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column 
            label="操作" 
            width="180"
          >
            <template #default="scope">
              <el-button 
                type="text" 
                @click="downloadFile(scope.row.fileUrl)"
                :disabled="!scope.row.fileUrl"
              >
                下载
              </el-button>
              <el-button 
                type="text" 
                @click="viewResult(scope.row.id)"
                :disabled="scope.row.status === 'pending'"
              >
                查看结果
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
  
</template>

<style scoped>
.upload-container {
  padding: 20px;
  background-color: #fff;
}

.title {
  font-size: 18px;
  /* font-weight: bold; */
  margin-bottom: 30px;
  text-align: center;
}

.upload-form {
  max-width: 800px;
  margin-bottom: 30px;
  margin-top: 20px;
  padding: 20px;
  padding-right: 50px;
  /* background-color: #fff; */
  border-radius: 4px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.project-list {
  margin-top: 30px;
}


.file-input {
  width: 100%;
  padding: 1px 12px;
  border: 2px dashed #9ec8e4;
  border-radius: 8px;
  background: #f9f9f9;
  font-size: 16px;
  color: #7f8c8d;
  /* color: #165DFF; */
  cursor: pointer;
  transition: all 0.3s ease;
}
.file-input:hover {
  border-color: #165DFF;
  background: #e8f5ff;
}
</style>